import { AxiosPromise } from 'axios';
import { IHoliday, IGetHolidays } from '../models/holidays.model';
import axios from 'axios';

const uri = '/mgmt/holidays';

export const getHolidays = (): AxiosPromise<IGetHolidays> => {
  return axios.get(uri);
}

export const createHoliday = (data: IHoliday): AxiosPromise => {
  return axios.post(uri, data);
};

export const updateHoliday = (id: string, data: IHoliday): AxiosPromise => {
  return axios.put(`${uri}/${id}`, data);
};

export const deleteHoliday = (id: string): AxiosPromise => {
  return axios.delete(`${uri}/${id}`);
};
